document.addEventListener('click', event => {
	const button = event.target.closest('section.annahme .line.button button');
	if (button) button.classList.add('is-clicked');
});
